import { proposalConstants } from '../Constants'
const proposalReducer = (state = {}, action) => {
  switch (action.type) {
    case proposalConstants.PROPOSALS_SUCCESS:
      return action.payload;
    case proposalConstants.PROPOSALS_FAILURE:
      return {};
    case proposalConstants.QPR_ENABLED_SUCCESS:
      return action.payload;
    case proposalConstants.QPR_ENABLED_FAILURE:
      return {};
    default:
      return state;
  }
}

export default proposalReducer;